module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.warehouse.index.title')) + " (" + _vm._s(_vm.warehouses.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions pull-right"
  }, [_c('v-text', {
    staticClass: "searchForm",
    attrs: {
      "name": "search",
      "type": "text",
      "translation": "search.title",
      "value": _vm.search
    },
    on: {
      "keydown": _vm.onChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "flex stretch wrap"
  }, [(_vm.warehouses.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.warehouse.noDataMsg')) + "\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'warehouse.create'
      }
    }
  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.warehouse.noDataBtn')) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.warehouses.items), function(p, i) {
    return _c('v-card', {
      key: i,
      attrs: {
        "wide": true
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editWarehouse(p)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link pull-right",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editWarehouseNewTab(p)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "full-w flex wrap client-title-container margin-b-10"
    }, [_c('img', {
      staticClass: "client-img margin-b-10",
      attrs: {
        "src": require("./../../../../../assets/images/warehouse.png"),
        "alt": ("" + (p.name))
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(("" + (p.name))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.warehouse.info.name')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.name || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.warehouse.info.location')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.location || '-'))])], _c('br'), _c('br'), _vm._v(" "), [_c('span', {
      staticClass: "cardContent"
    }, [(p.typeName == 'Standard') ? [_c('el-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_vm._v(_vm._s(_vm.returnWarehouseType(p.typeName, p.isBonded)))])] : [_c('el-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v(_vm._s(_vm.returnWarehouseType(p.typeName, p.isBonded)))])]], 2)]], 2)
  })], 2)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.warehouses.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dbda9f4","hasScoped":true}!./src/app/pages/withNavigation/warehouse/index/index.html
// module id = 3053
// module chunks = 1